"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import TileContainer from "./TileContainer";
let CarouselTiles = class extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { extraSidePadding, tileWidth, totalWidth } = this.props.carouselControllerStore;
    const tilesBefore = Math.max(0, this.startContentIndex);
    const paddingLeft = tilesBefore * tileWidth + extraSidePadding;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "carousel__tiles-container",
        style: {
          paddingLeft,
          width: totalWidth
        }
      },
      this.tileContainers
    );
  }
  get tileContainers() {
    const { tileProvider, tileWidth } = this.props.carouselControllerStore;
    const items = [];
    for (let i = 0; i < this.visibleTilesPerPage; ++i) {
      const contentIndex = this.startContentIndex + i;
      if (contentIndex < 0) {
        continue;
      }
      if (contentIndex >= tileProvider.contentCount) {
        break;
      }
      const tileContainer = /* @__PURE__ */ React.createElement(
        TileContainer,
        {
          key: contentIndex,
          contentIndex,
          tileWidth,
          getContent: this.boundGetContent
        }
      );
      items.push(tileContainer);
    }
    return items;
  }
  get startContentIndex() {
    const { currentScrollPosition, extraSidePadding, tileWidth } = this.props.carouselControllerStore;
    return Math.floor((currentScrollPosition - extraSidePadding) / tileWidth);
  }
  get visibleTilesPerPage() {
    const { componentWidth, tileWidth } = this.props.carouselControllerStore;
    return Math.ceil(componentWidth / tileWidth) + 1;
  }
  get boundGetContent() {
    const { tileProvider } = this.props.carouselControllerStore;
    return tileProvider.getContent.bind(this);
  }
};
__decorateClass([
  computed
], CarouselTiles.prototype, "tileContainers", 1);
__decorateClass([
  computed
], CarouselTiles.prototype, "startContentIndex", 1);
__decorateClass([
  computed
], CarouselTiles.prototype, "visibleTilesPerPage", 1);
__decorateClass([
  computed
], CarouselTiles.prototype, "boundGetContent", 1);
CarouselTiles = __decorateClass([
  observer
], CarouselTiles);
export {
  CarouselTiles as default
};
